import Render from './Render/Render';

interface SerializedTableColumn {
  title: string;
  dataIndex: string;
  key: string;

  [key: string]: any;
}

class TableColumn {
  public get = (): SerializedTableColumn => {
    const {title, dataIndex, key, render, sorter} = this;
    let {additional} = this;

    if (render) {
      additional = {...additional, render}
    }
    if (sorter) {
      additional = {...additional, sorter}
    }

    const columns = {title, dataIndex, key};

    return {...columns, ...additional};
  };
  public setRender = (render) => {
    this.render = render;
    return this;
  };
  public setSorter = (sorter: boolean) => {
    this.sorter = sorter;
    return this;
  };
  public setAdditional = (additional: {}) => {
    this.additional = {...this.additional, ...additional};
    return this;
  }
  private title: string;
  private dataIndex: string;
  private key: string;
  private render?: Render;
  private sorter?: any;
  private additional: {};

  public constructor(title: any, dataIndex: string, key: string) {
    this.title = title;
    this.dataIndex = dataIndex;
    this.key = key;
    this.additional = {};
  };
}

export default TableColumn;
